/* src/app/components/submission-device-characteristics-us/submission-device-characteristics-us.component.css */
/*# sourceMappingURL=submission-device-characteristics-us.component.css.map */
